"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var encryption_1 = tslib_1.__importDefault(require("./encryption"));
var encryption_2 = require("./encryption");
var StorageClient = /** @class */ (function () {
    function StorageClient(DEBUG, storage) {
        if (DEBUG === void 0) { DEBUG = false; }
        if (storage === void 0) { storage = localStorage; }
        this.DEBUG = DEBUG;
        this.storage = storage;
    }
    StorageClient.prototype.getItem = function (key) {
        if (this.DEBUG) {
            return this.storage.getItem(key);
        }
        try {
            var raw = this.storage.getItem(encryption_2.btoa(key));
            if (!raw) {
                throw new Error('Empty key');
            }
            var decrypted = encryption_1.default.decryptText(raw);
            return decrypted;
        }
        catch (error) {
            // localStorage
            return null;
        }
    };
    StorageClient.prototype.setItem = function (key, value) {
        if (this.DEBUG) {
            return this.storage.setItem(key, value);
        }
        var encrypted = encryption_1.default.encryptText(value || '');
        return this.storage.setItem(encryption_2.btoa(key), encrypted);
    };
    StorageClient.prototype.removeItem = function (key) {
        if (this.DEBUG) {
            return this.storage.removeItem(key);
        }
        return this.storage.removeItem(encryption_2.btoa(key));
    };
    StorageClient.prototype.get = function (key) {
        var result = this.getItem(key);
        try {
            return JSON.parse(result);
        }
        catch (e) {
            return result;
        }
    };
    StorageClient.prototype.set = function (key, value) {
        if (typeof value === 'string') {
            return this.setItem(key, value);
        }
        return this.setItem(key, JSON.stringify(value));
    };
    StorageClient.prototype.pop = function (key) {
        var item = this.get(key);
        this.removeItem(key);
        return item;
    };
    return StorageClient;
}());
exports.StorageClient = StorageClient;
